/** Drawer hosts teleported into #slide-in-group; all live in the header section. */
const TELEPORTED_DRAWER_SELECTORS = ['cart-drawer', 'header-drawer'];

/**
 * Re-teleport drawer panels after the header section is morphed.
 * Cart updates morph the whole header, so both cart and mobile menu must reconcile.
 */
export function reconcileCartDrawerPanels() {
  for (const selector of TELEPORTED_DRAWER_SELECTORS) {
    const host = document.querySelector(selector);
    if (host && typeof host.reconcilePanels === 'function') {
      host.reconcilePanels();
    }
  }
}
